import { game } from '../main';
import { Popup, ISlider } from './Popup';
import { changeTexture } from '../utils/changeTexture';
//import { storage } from 'GBCXPromo';
import { GameState } from './../States/GameState';

declare const GBCXPromo;

export class PopupSetup extends Popup {
  public signals = {
    onGameOver: new Phaser.Signal(),
  };
  private colorOnStart: string;
  private soundOnStart: boolean;
  private animationsOnStart: boolean;

  private sliderR: ISlider;
  private sliderG: ISlider;
  private sliderB: ISlider;
  private setDifficultyBtn;
  private setArrowBtn;
  private difficultyLevelOnStart;

  private selectedPointer = 0;


  constructor() {
    super();
    this.addTitle(game.getText(2));

    this.selectedPointer =  game.arrowPointer ? 0 : 1;

    this.colorOnStart = GBCXPromo.storage.getStorageValue('backgroundColor', '#3e4272');
    this.soundOnStart = game.sound.mute;
    this.animationsOnStart = GBCXPromo.storage.getStorageValue('animations', true);

    this.addLabel(-220, -220, game.getText(7));

    this.sliderR = this.addSlider(-220, -150,
      parseInt(game.config.backgroundColor.slice(1, 3), 16) / 255,
      255, 250, '0_bubble_red');
    this.sliderR.onSliderMove.add(() => this.setupRefreshGlobalColor());
    this.sliderG = this.addSlider(-220, -100,
      parseInt(game.config.backgroundColor.slice(3, 5), 16) / 255,
      255, 250, '0_bubble_green');
    this.sliderG.onSliderMove.add(() => this.setupRefreshGlobalColor());
    this.sliderB = this.addSlider(-220, -50,
      parseInt(game.config.backgroundColor.slice(5), 16) / 255,
      255, 250, '0_bubble_blue');
    this.sliderB.onSliderMove.add(() => this.setupRefreshGlobalColor());


    const restartBtn = this.addLabelButton(-220, 0, game.getText(21), 260, 'checkmark_unselect');
    restartBtn.button.onClick.add(() => {
      this.sliderR.changePos(0.2431372549019608);
      this.sliderG.changePos(0.2588235294117647);
      this.sliderB.changePos(0.4470588235294118);
      this.setupRefreshGlobalColor();
    });
    this.difficultyLevelOnStart = game.gameDifficultyLevel

    this.addButton(150, -60, 'button_small', game.getText(5), () => {
      GBCXPromo.storage.save({
        backgroundColor: game.config.backgroundColor,
      });
      this.closeWindow();
      if (this.difficultyLevelOnStart !=  game.gameDifficultyLevel) {
        GBCXPromo.storage.save({
          gameDifficultyLevel: game.gameDifficultyLevel
        });
        this.signals.onGameOver.dispatch(false);
        game.state.restart(false)
        GBCXPromo.gameStart();
        game.state.start(GameState.key);
      }
    });


    this.addButton(150, -140, 'button_small', game.getText(6), () => {
      document.body.style.backgroundColor = this.colorOnStart;
      game.config.backgroundColor = this.colorOnStart;
      game.sound.mute = this.soundOnStart;
      GBCXPromo.storage.save({
        animations: this.animationsOnStart
      });
      this.closeWindow();
    });


    this.addLabel(-220, 55, game.getText(8));

    // difficulty radio buttons
    // this.addLabel(120, 215, game.getText(38));
    this.setDifficultyBtn = [
      this.addLabelButton(-220, 125, game.getText(39)),
      this.addLabelButton(-60, 125, game.getText(40)),
      this.addLabelButton(100, 125, game.getText(41))
    ];

    this.setupRefreshLevelButtons();

    this.setDifficultyBtn.forEach((btnLabel, index) => {
      btnLabel.button.onClick.add(() => {

        game.gameDifficultyLevel = index;
        let difficultyText = this.getDifficultyString(game.gameDifficultyLevel);

        this.setupRefreshLevelButtons();
      }, btnLabel.button);
    });

    this.setDifficultyBtn[1].inputEnabled = false;
    this.setDifficultyBtn[2].inputEnabled = false;


    this.setArrowBtn = [
      this.addLabelButton(-220, 165, game.getText(42)),
      this.addLabelButton(-60, 165, game.getText(43)),
    ];
    this.setArrowBtn.forEach((btnLabel, index) => {
      btnLabel.button.onClick.add(() => {
        this.selectedPointer = index;
        GBCXPromo.storage.save({
          pointer: this.selectedPointer === 0,
        });
        game.arrowPointer = index === 0;
        this.setupRefreshArrowButtons()
      }, btnLabel.button);
    });
    this.setupRefreshArrowButtons();

    const soundBtn = this.addLabelButton(-220, 205, game.getText(12));
    changeTexture(soundBtn.button, game.sound.mute ? 'checkmark_unselect' : 'checkmark_select');

    soundBtn.button.onClick.add(() => {
      game.sound.mute = !game.sound.mute;
      GBCXPromo.storage.save({mute: game.sound.mute});
      changeTexture(soundBtn.button, game.sound.mute ? 'checkmark_unselect' : 'checkmark_select');
    });


    const animationBtn = this.addLabelButton(-220, 245, game.getText(23));
    animationBtn.button.onClick.add(() => {
      GBCXPromo.storage.save({animations: !GBCXPromo.storage.getStorageValue('animations', true)});
      changeTexture(animationBtn.button, GBCXPromo.storage.getStorageValue('animations', true) ? 'checkmark_select' : 'checkmark_unselect');
    });
    changeTexture(animationBtn.button, GBCXPromo.storage.getStorageValue('animations', true) ? 'checkmark_select' : 'checkmark_unselect');
  }

  private setupRefreshLevelButtons() {
    this.setDifficultyBtn.forEach(function(e, index) {
      e.gameDifficultyLevel = index;
      if (e.gameDifficultyLevel == game.gameDifficultyLevel) {
        changeTexture(e.button, 'checkmark_select');
      } else {
        changeTexture(e.button, 'checkmark_unselect')
      }
    }, this);
  }

  private setupRefreshArrowButtons() {
    this.setArrowBtn.forEach((e, index) =>{
      console.log("index is " + index);
      console.log("pointer is " +this.selectedPointer)
      if (index == this.selectedPointer) {
        changeTexture(e.button, 'checkmark_select');
      } else {
        changeTexture(e.button, 'checkmark_unselect')
      }
    }, this);
  }

  private getDifficultyString(difficulty) {
    var difficultyString = '';

    switch(difficulty) {
      case 0:
      difficultyString = game.getText(9);
      break;
      case 1:
      difficultyString = game.getText(10);
      break;
      case 2:
      difficultyString = game.getText(11);
      break;
    }
    return difficultyString;
  }

  private setupRefreshGlobalColor(): void {
    let red = this.sliderR.getValue().toString(16);
    let green = this.sliderG.getValue().toString(16);
    let blue = this.sliderB.getValue().toString(16);

    if (red.length == 1) red = '0' + red;
    if (green.length == 1) green = '0' + green;
    if (blue.length == 1) blue = '0' + blue;

    game.config.backgroundColor = '#' + red + green + blue;
    document.body.style.backgroundColor = game.config.backgroundColor;
    this.drawWindow(500, 660);
  }
}
